import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AdsenseModule } from 'ng2-adsense';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import { AutoFocusDirective } from './auto-focus.directive';
import { NoAccessComponent } from './no-access/no-access.component';
import { MatButtonModule } from '@angular/material';
import {MatProgressBarModule} from '@angular/material/progress-bar';



export const createTranslateLoader = (http: HttpClient) => {
  /* for development
  return new TranslateHttpLoader(
      http,
      '/start-javascript/sb-admin-material/master/dist/assets/i18n/',
      '.json'
  );*/
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

@NgModule({
  declarations: [
    AppComponent,
    AutoFocusDirective,
    NoAccessComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatButtonModule,
    MatProgressBarModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
      }
  }),
  AdsenseModule.forRoot({
    adClient: 'ca-pub-3247424821998171',
    
  }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
